import { InjectionToken } from '@angular/core';
import type { Observable } from 'rxjs';

export interface EmailAnalyticsChartsParams {
  readonly incidentNumber: string;
  readonly medicationName: string;
}

/**
 * Response shape: five chart configs for the send-email analytics section.
 * Each property is a boxplot (or boxplot+line/scatter) config consumed by app-generic-chart.
 */
export interface EmailAnalyticsCharts {
  readonly medRemovalRisk: unknown;
  readonly wasteTransactionsRisk: unknown;
  readonly chartedRisk: unknown;
  readonly unaccountedVariancesRisk: unknown;
  readonly employeeRiskPerAudit: unknown;
}

export interface EmailAnalyticsClient {
  getCharts(params: EmailAnalyticsChartsParams): Observable<EmailAnalyticsCharts>;
}

export const EMAIL_ANALYTICS_CLIENT = new InjectionToken<EmailAnalyticsClient>(
  'EMAIL_ANALYTICS_CLIENT'
);
